import { createStore } from 'vuex'
import getters from './getters'

const files = require.context('./modules', false, /\.js$/)
const modules = {}
const debug = process.env.NODE_ENV !== 'production'

files.keys().forEach((key) => {
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})
/**
 * todo - tips：使用[namespaced]属性后，在store间调用[dispatch\actions\mutations]方法，要添加第三个参数[{ root: true })]
 */
Object.keys(modules).forEach((key) => {
  modules[key].namespaced = key !== 'base'
})

export default createStore({
  modules,
  getters,
  strict: debug
})
